/**
 * Trata mensagens FCM em foreground (app aberto).
 * Exibe toast e adiciona à lista de notificações quando uma push chega.
 * Nunca lança exceção: app funciona mesmo sem permissão de notificação.
 */

import { useCallback } from 'react'
import { useForegroundMessages } from '@/shared/lib/useForegroundMessages'
import { useToast } from '@/shared/ui/toast'
import { useNotificationsStore } from '@/features/notifications/model/notificationsStore'
import type { MessagePayload } from 'firebase/messaging'

export const ForegroundMessageHandler = () => {
  const toast = useToast()
  const addNotification = useNotificationsStore((s) => s.add)

  const handleMessage = useCallback(
    (payload: MessagePayload) => {
      try {
        const data = (payload?.data ?? {}) as Record<string, string>
        const title =
          payload?.notification?.title ?? data?.title ?? 'Lembrete'
        const body =
          payload?.notification?.body ?? data?.body ?? ''
        const eventId = data?.eventId
        const kind = data?.synapPushKind

        toast.pushNotification(title, body || undefined)

        if (kind === 'event_reminder' && eventId) {
          addNotification('event_reminder', title, body || undefined, {
            eventId,
            url: `/calendar?event=${encodeURIComponent(eventId)}`,
          })
        }
      } catch {
        /* ignora: não bloqueia o app */
      }
    },
    [toast, addNotification],
  )

  useForegroundMessages(handleMessage)

  return null
}
